/**
 * Authentication Library
 * Uses custom JWT-based authentication (replaces Supabase Auth)
 */

import { auth, User } from './api';

export type { User };

/**
 * Register a new user
 */
export async function signUp(
  email: string,
  password: string,
  metadata: { fullName?: string; companyName?: string } = {}
) {
  const result = await auth.signUp(email, password, metadata.fullName, metadata.companyName);
  return result;
}

/**
 * Login user
 */
export async function signIn(email: string, password: string) {
  const result = await auth.signIn(email, password);
  return result;
}

/**
 * Logout user
 */
export async function signOut() {
  await auth.signOut();
}

/**
 * Get current user
 */
export async function getCurrentUser(): Promise<User | null> {
  return auth.getUser();
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated(): boolean {
  return auth.isAuthenticated();
}

/**
 * Check if current user is admin
 */
export async function isAdmin(): Promise<boolean> {
  const user = await getCurrentUser();
  return user?.role === 'admin';
}

/**
 * Check if admin user exists (for initial setup)
 */
export async function checkAdminExists(): Promise<boolean> {
  return auth.adminExists();
}

/**
 * Create admin user (initial setup only)
 */
export async function createAdminUser(
  email: string,
  password: string,
  fullName: string = 'Admin User'
): Promise<User> {
  return auth.createAdmin(email, password, fullName);
}
